import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const Container = styled.div({
  width: '100%'
})

export const CopyContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',

  svg: {
    marginBottom: tokens.spacing[3]
  }
})
